import * as React from "react";

function SvgSimpleReach(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 1000 154"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <defs>
        <linearGradient
          x1="358.082%"
          y1="-240.28%"
          x2="1168.655%"
          y2="350.856%"
          id="SimpleReach_svg__a"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="1381.095%"
          y1="-152.268%"
          x2="6525.116%"
          y2="288.406%"
          id="SimpleReach_svg__b"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="76.75%"
          y1="-243.445%"
          x2="482.344%"
          y2="356.306%"
          id="SimpleReach_svg__c"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-70.78%"
          y1="-186.152%"
          x2="546.265%"
          y2="272.663%"
          id="SimpleReach_svg__d"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-2088.882%"
          y1="-145.395%"
          x2="4279.906%"
          y2="283.273%"
          id="SimpleReach_svg__e"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-258.926%"
          y1="-237.997%"
          x2="398.295%"
          y2="348.602%"
          id="SimpleReach_svg__f"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-595.382%"
          y1="-232.783%"
          x2="419.757%"
          y2="348.539%"
          id="SimpleReach_svg__g"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-430.739%"
          y1="-227.339%"
          x2="181.364%"
          y2="340.579%"
          id="SimpleReach_svg__h"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-582.906%"
          y1="-229.575%"
          x2="68.711%"
          y2="342.594%"
          id="SimpleReach_svg__i"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-692.911%"
          y1="-226.992%"
          x2="-53.749%"
          y2="340.324%"
          id="SimpleReach_svg__j"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
        <linearGradient
          x1="-842.674%"
          y1="-145.279%"
          x2="-182.207%"
          y2="283.047%"
          id="SimpleReach_svg__k"
        >
          <stop stopColor="#A9BD74" offset="0%" />
          <stop stopColor="#9EB372" offset="10.34%" />
          <stop stopColor="#859C70" offset="25.97%" />
          <stop stopColor="#637B69" offset="44.96%" />
          <stop stopColor="#37565D" offset="66.39%" />
          <stop stopColor="#134054" offset="80.16%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M35.7 127.4c-12.7 0-26.5-5.1-35.7-12.7l5-6.7c9.6 7.4 20.2 11.5 31.3 11.5 11.8 0 21-6.5 21-16.6v-.3c0-10.3-10.9-14-23.1-17.4C20 81.1 4.3 76.8 4.3 61.3V61c0-14 11.8-24.1 28.7-24.1 10.4 0 22.2 3.8 31 9.6l-4.4 7c-8-5.3-17.6-8.7-26.8-8.7-12 0-19.8 6.5-19.8 15.2v.3c0 9.7 11.8 13.3 24.3 16.9 14 3.9 28.7 9.1 28.7 24.5v.3c-.2 15.5-13.5 25.4-30.3 25.4z"
          fill="url(#SimpleReach_svg__a)"
        />
        <path
          d="M92.7 15.8V4.3h10.4v11.5H92.7zm1 109.9V38.5h8.4v87.2h-8.4z"
          fill="url(#SimpleReach_svg__b)"
        />
        <path
          d="M258.6 125.7V73.9c0-18.8-9.7-29.8-25.8-29.8-14.7 0-27.5 11.3-27.5 30.8v50.8h-8.4V73.4c0-18.1-9.9-29.2-25.5-29.2s-27.9 13.7-27.9 31.3v50.3h-8.4V38.6h8.4v15.6c5.6-9.1 13.5-17.6 29.1-17.6 15.2 0 24.6 8.7 29.4 18.8 5.6-9.7 15-18.8 31.5-18.8 20.7 0 33.5 14.5 33.5 36.4v52.8h-8.4v-.1z"
          fill="url(#SimpleReach_svg__c)"
        />
        <path
          d="M342 127.8c-17.4 0-28.7-9.9-35.9-20.9v46.2h-8.4V38.5h8.4V58c7.5-11.5 18.6-21.5 35.9-21.5 21 0 42.4 16.9 42.4 45.3v.3c0 28.4-21.4 45.7-42.4 45.7zm33.3-45.7c0-22.9-15.9-37.6-34.2-37.6-18.1 0-35.6 15.2-35.6 37.5v.3c0 22.4 17.4 37.5 35.6 37.5 19 0 34.2-13.9 34.2-37.3v-.4z"
          fill="url(#SimpleReach_svg__d)"
        />
        <path
          d="M411.8 125.7V.9h8.4v124.8h-8.4z"
          fill="url(#SimpleReach_svg__e)"
        />
        <path
          d="M490.3 119.9c13.5 0 22.7-6 29.9-13.7l5.8 5.1c-8.9 9.6-19.3 16.4-36.1 16.4-22.9 0-42.8-18.3-42.8-45.5V82c0-25.3 17.8-45.5 41.4-45.5 24.5 0 40 19.8 40 45.7v.3c0 1.2 0 1.7-.2 3.1H456c1.6 21.7 17.2 34.3 34.3 34.3zM519.5 78c-1.2-17.6-11.3-33.9-31.3-33.9-17.3 0-30.6 14.5-32.1 33.9h63.4z"
          fill="url(#SimpleReach_svg__f)"
        />
        <path
          d="M570.8 125.7h-20.7V35.4h20.7v20.4c5.6-13.5 16.1-22.7 32-22.1v21.9h-1.2c-18.1 0-30.8 11.8-30.8 35.7v34.4z"
          fill="url(#SimpleReach_svg__g)"
        />
        <path
          d="M659.4 110.9c10.1 0 17.3-3.8 24.5-10.8l12.1 10.8c-8.6 10.3-20.4 16.9-36.9 16.9-26.2 0-46.3-19-46.3-47 0-26 18.3-47.2 44.1-47.2 28.7 0 43.3 22.6 43.3 48.7 0 1.9-.2 3.6-.3 5.6h-66.4c2.3 14.8 12.5 23 25.9 23zm20.1-36.6c-1.4-13.3-9.2-23.8-22.9-23.8-12.7 0-21.5 9.7-23.4 23.8h46.3z"
          fill="url(#SimpleReach_svg__h)"
        />
        <path
          d="M776.2 125.7v-11.1c-6.2 7.4-15.6 13-29.2 13-17.1 0-32.1-9.7-32.1-27.9v-.3c0-19.5 15.6-29.1 36.6-29.1 10.9 0 18 1.5 25 3.8v-2.2c0-12.5-7.9-19.3-22.2-19.3-10.1 0-17.6 2.2-25.8 5.6l-5.6-16.6c9.9-4.4 19.7-7.5 34.4-7.5 26.7 0 39.7 14 39.7 38.1v53.5h-20.8zm.5-38.3c-5.3-2.1-12.7-3.6-20.7-3.6-13 0-20.7 5.3-20.7 14.5v.3c0 8.6 7.7 13.3 17.4 13.3 13.7 0 23.9-7.7 23.9-19v-5.5h.1z"
          fill="url(#SimpleReach_svg__i)"
        />
        <path
          d="M863 127.8c-26.8 0-46.7-21-46.7-46.9s19.8-47.4 46.9-47.4c17.1 0 27.7 6.3 36.1 15.6L886.5 63c-6.3-6.7-13-11.3-23.4-11.3-15 0-26 13-26 28.9 0 16.2 11.1 29.2 27 29.2 9.7 0 16.9-4.6 23.4-11.3l12.5 12.3c-8.9 10-19.4 17-37 17z"
          fill="url(#SimpleReach_svg__j)"
        />
        <path
          d="M939.6 125.7h-20.7V.9h20.7v48.6c5.8-8.6 14.2-15.9 28.2-15.9 20.4 0 32.1 13.7 32.1 34.7v57.5h-20.7V74.5c0-14-7-22.1-19.3-22.1-12 0-20.3 8.4-20.3 22.4v50.9z"
          fill="url(#SimpleReach_svg__k)"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSimpleReach);
